// import { Box } from "@mui/material";
// import React, { useState, useEffect } from "react";
// import {
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   ResponsiveContainer,
//   PieChart,
//   Pie,
//   Cell,
//   Legend,
// } from "recharts";

// const HiringCompanies = () => {
//   // State for API data
//   const [companyStats, setCompanyStats] = useState({
//     totalCompanies: 100,
//     activeCompanies: 75,
//     inactiveCompanies: 25,
//   });

//   // Fetch data from API
//   useEffect(() => {
//     const fetchCompanyStats = async () => {
//       try {
//         const response = await fetch(
//           "http://localhost:3000/super-admin/company-activity-stats"
//         );
//         const result = await response.json();

//         if (result.success) {
//           setCompanyStats(result.data);
//         }
//       } catch (error) {
//         console.error("Error fetching company stats:", error);
//       }
//     };

//     fetchCompanyStats();
//   }, []);

//   // Data for bar chart (unchanged)
//   const barData = [
//     { name: "TechGiant Inc.", hires: 520 },
//     { name: "InnovaCorp", hires: 180 },
//     { name: "GlobalTech", hires: 340 },
//     { name: "NextGen Ltd.", hires: 320 },
//     { name: "FutureSoft", hires: 290 },
//   ];

//   // Data for pie chart (now using API data - showing counts instead of percentages)
//   const pieData = [
//     {
//       name: "Active",
//       value: companyStats.activeCompanies,
//       count: companyStats.activeCompanies,
//     },
//     {
//       name: "Inactive",
//       value: companyStats.inactiveCompanies,
//       count: companyStats.inactiveCompanies,
//     },
//   ];

//   // Colors for charts
//   const barColors = ["#3B82F6", "#10B981", "#EF4444", "#F59E0B", "#8B5CF6"];
//   const pieColors = ["#10B981", "#EF4444"];

//   const CustomTooltip = ({ active, payload, label }) => {
//     if (active && payload && payload.length) {
//       return (
//         <div
//           style={{
//             backgroundColor: "white",
//             padding: "12px 16px",
//             border: "1px solid #E5E7EB",
//             borderRadius: "8px",
//             boxShadow: "0 10px 25px rgba(0, 0, 0, 0.15)",
//             fontSize: "14px",
//             fontWeight: "500",
//           }}
//         >
//           <p style={{ margin: 0, color: "#374151" }}>
//             {`${label}: ${payload[0].value} hires`}
//           </p>
//         </div>
//       );
//     }
//     return null;
//   };

//   const PieTooltip = ({ active, payload }) => {
//     if (active && payload && payload.length) {
//       return (
//         <div
//           style={{
//             backgroundColor: "white",
//             padding: "8px 12px",
//             border: "1px solid #E5E7EB",
//             borderRadius: "6px",
//             boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//           }}
//         >
//           <p style={{ margin: 0, fontSize: "13px", color: "#374151" }}>
//             {`${payload[0].name}: ${payload[0].value}%`}
//           </p>
//         </div>
//       );
//     }
//     return null;
//   };

//   const renderCustomizedLabel = ({ cx, cy, percent }) => {
//     if (percent > 0.6) {
//       return (
//         <text
//           x={cx}
//           y={cy}
//           fill="#10B981"
//           textAnchor="middle"
//           dominantBaseline="central"
//           fontSize="20px"
//           fontWeight="600"
//         >
//           {/* 75.00% */}
//         </text>
//       );
//     }
//     return null;
//   };

//   return (
//     <Box
//       sx={{
//         padding: {
//           xs: "12px",
//           sm: "16px",
//           md: "20px",
//           lg: "24px",
//           xl: "24px",
//         },
//         ml: {
//           xs: "0",
//           sm: "0",
//           md: "180px",
//           lg: "220px",
//           xl: "220px",
//         },
//         mt: {
//           xs: "0",
//           sm: "0",
//           md: "-1%",
//           lg: "-1%",
//           xl: "-1%",
//         },
//         fontFamily: "system-ui, -apple-system, sans-serif",
//       }}
//     >
//       <Box
//         sx={{
//           display: "grid",
//           gridTemplateColumns: {
//             xs: "1fr",
//             sm: "1fr",
//             md: "1fr 1fr",
//             lg: "2fr 2fr",
//             xl: "2fr 2fr",
//           },
//           gap: {
//             xs: "16px",
//             sm: "20px",
//             md: "24px",
//             lg: "24px",
//             xl: "24px",
//           },
//           marginLeft: {
//             xs: "0",
//             sm: "0",
//             md: "1%",
//             lg: "1%",
//             xl: "1%",
//           },
//           marginRight: {
//             xs: "0",
//             sm: "0",
//             md: "2%",
//             lg: "2%",
//             xl: "2%",
//           },
//         }}
//       >
//         {/* Top Hiring Companies Chart */}
//         {/* Top Hiring Companies Chart */}
//         <Box
//           sx={{
//             backgroundColor: "white",
//             padding: {
//               xs: "16px",
//               sm: "20px",
//               md: "24px",
//               lg: "24px",
//               xl: "24px",
//             },
//             borderRadius: "12px",
//             border: "1px solid #E5E7EB",
//             boxShadow: "0 4px 6px rgba(0, 0, 0, 0.05)",
//             position: "relative", // Add this for overlay positioning
//           }}
//         >
//           <Box sx={{ marginBottom: { xs: "16px", sm: "20px" } }}>
//             <h2
//               style={{
//                 fontSize: "18px",
//                 fontWeight: "600",
//                 color: "#111827",
//                 margin: "0 0 8px 0",
//                 textAlign: "left",
//               }}
//             >
//               Top Hiring Companies
//             </h2>
//             <Box
//               sx={{
//                 display: "flex",
//                 gap: { xs: "12px", sm: "24px" },
//                 alignItems: "center",
//                 flexWrap: "wrap",
//                 flexDirection: { xs: "column", sm: "row" },
//                 alignItems: { xs: "flex-start", sm: "center" },
//               }}
//             >
//               <span style={{ fontSize: "13px", color: "#6B7280" }}>
//                 Total Hires: 1,670
//               </span>
//               <span style={{ fontSize: "13px", color: "#6B7280" }}>
//                 Top Hiring Company: TechGiant Inc.
//               </span>
//             </Box>
//           </Box>

//           <Box
//             sx={{
//               height: { xs: "280px", sm: "300px", md: "320px" },
//               width: "100%",
//               filter: "blur(3px)", // Add blur effect
//             }}
//           >
//             <ResponsiveContainer width="100%" height="100%">
//               <BarChart
//                 data={barData}
//                 margin={{ top: 20, right: 30, left: 20, bottom: -20 }}
//               >
//                 <CartesianGrid
//                   strokeDasharray="3 3"
//                   stroke="#F3F4F6"
//                   vertical={false}
//                 />
//                 <XAxis
//                   dataKey="name"
//                   tick={{ fontSize: 11, fill: "#6B7280" }}
//                   angle={-45}
//                   textAnchor="end"
//                   height={80}
//                   interval={0}
//                   axisLine={{ stroke: "#E5E7EB" }}
//                   tickLine={{ stroke: "#E5E7EB" }}
//                 />
//                 <CartesianGrid
//                   strokeDasharray="3 3"
//                   stroke="#F3F4F6"
//                   horizontal={false}
//                   vertical={true}
//                 />
//                 <YAxis
//                   tick={{ fontSize: 11, fill: "#6B7280" }}
//                   label={{
//                     value: "Number of Hires",
//                     angle: -90,
//                     position: "insideLeft",
//                     style: {
//                       textAnchor: "middle",
//                       fontSize: "12px",
//                       fill: "#6B7280",
//                     },
//                   }}
//                   axisLine={{ stroke: "#E5E7EB" }}
//                   tickLine={{ stroke: "#E5E7EB" }}
//                 />
//                 <Tooltip
//                   content={<CustomTooltip />}
//                   cursor={{ fill: "transparent" }}
//                 />
//                 <Bar
//                   dataKey="hires"
//                   radius={[25, 25, 0, 0]}
//                   stroke="#fff"
//                   strokeWidth={1}
//                   barSize={100}
//                 >
//                   {barData.map((entry, index) => (
//                     <Cell
//                       key={`cell-${index}`}
//                       fill={barColors[index]}
//                       style={{
//                         filter: "drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1))",
//                       }}
//                     />
//                   ))}
//                 </Bar>
//               </BarChart>
//             </ResponsiveContainer>
//           </Box>

//           {/* Coming Soon Overlay */}
//           <Box
//             sx={{
//               position: "absolute",
//               top: 0,
//               left: 0,
//               right: 0,
//               bottom: 0,
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               backgroundColor: "rgba(255, 255, 255, 0.7)",
//               borderRadius: "12px",
//               zIndex: 10,
//             }}
//           >
//             <h3
//               style={{
//                 margin: "0",
//                 fontSize: "28px",
//                 fontWeight: "700",
//                 color: "#2B3674",
//                 fontFamily: "Outfit",
//                 textAlign: "center",
//                 textShadow: "0 2px 4px rgba(0,0,0,0.1)",
//               }}
//             >
//               Coming Soon
//             </h3>
//           </Box>
//         </Box>

//         {/* Active vs Inactive Companies Chart */}
//         <Box
//           sx={{
//             backgroundColor: "white",
//             padding: {
//               xs: "16px",
//               sm: "20px",
//               md: "24px",
//               lg: "24px",
//               xl: "24px",
//             },
//             borderRadius: "12px",
//             border: "1px solid #E5E7EB",
//             position: "relative",
//           }}
//         >
//           <Box sx={{ marginBottom: { xs: "16px", sm: "20px" } }}>
//             <h2
//               style={{
//                 fontSize: "20px",
//                 fontWeight: "600",
//                 color: "#111827",
//                 margin: "0 0 8px 0",
//                 textAlign: "left",
//               }}
//             >
//               Active vs. Inactive Companies
//             </h2>
//             <Box
//               sx={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 width: "100%",
//                 flexDirection: { xs: "column", sm: "row" },
//                 gap: { xs: "8px", sm: "0" },
//                 alignItems: { xs: "flex-start", sm: "center" },
//               }}
//             >
//               <span style={{ fontSize: "14px", color: "#6B7280" }}>
//                 Total Companies: {companyStats.totalCompanies}
//               </span>
//               <span
//                 style={{
//                   fontSize: "14px",
//                   color: "#10B981",
//                   fontWeight: "500",
//                 }}
//               >
//                 Active Companies: {companyStats.activeCompanies}
//               </span>
//             </Box>
//           </Box>

//           <Box
//             sx={{
//               height: { xs: "280px", sm: "300px", md: "320px" },
//               width: "100%",
//             }}
//           >
//             <ResponsiveContainer width="100%" height="100%">
//               <PieChart>
//                 <Pie
//                   data={[
//                     {
//                       name: "Active",
//                       value: companyStats.activeCompanies,
//                       color: "#10B981",
//                     },
//                     {
//                       name: "Inactive",
//                       value: companyStats.inactiveCompanies,
//                       color: "#EF4444",
//                     },
//                   ]}
//                   cx="50%"
//                   cy="45%"
//                   labelLine={{
//                     stroke: "#6B7280",
//                     strokeWidth: 1.5,
//                   }}
//                   label={({
//                     name,
//                     value,
//                     cx,
//                     cy,
//                     midAngle,
//                     innerRadius,
//                     outerRadius,
//                   }) => {
//                     const RADIAN = Math.PI / 180;
//                     const radius =
//                       innerRadius + (outerRadius - innerRadius) * 1.5;
//                     const x = cx + radius * Math.cos(-midAngle * RADIAN);
//                     const y = cy + radius * Math.sin(-midAngle * RADIAN);
//                     const color = name === "Active" ? "#10B981" : "#EF4444";

//                     // Adjust y position for cleaner look
//                     const adjustedY = name === "Active" ? y - 18 : y + 18;

//                     return (
//                       <text
//                         x={x}
//                         y={adjustedY}
//                         fill={color}
//                         textAnchor={x > cx ? "start" : "end"}
//                         dominantBaseline="central"
//                         fontSize="14px"
//                         fontWeight="500"
//                       >
//                         {`${name}: ${value}`}
//                       </text>
//                     );
//                   }}
//                   outerRadius={70}
//                   innerRadius={45}
//                   fill="#8884d8"
//                   dataKey="value"
//                   startAngle={90}
//                   endAngle={450}
//                   paddingAngle={2}
//                 >
//                   <Cell fill="#10B981" />
//                   <Cell fill="#EF4444" />
//                 </Pie>
//                 <Tooltip
//                   formatter={(value) => [value, ""]}
//                   labelStyle={{ display: "none" }}
//                 />
//               </PieChart>
//             </ResponsiveContainer>

//             {/* Custom Legend */}
//             <Box
//               sx={{
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 gap: { xs: "16px", sm: "24px" },
//                 marginTop: "-30px",
//                 flexDirection: { xs: "column", sm: "row" },
//               }}
//             >
//               <Box
//                 style={{ display: "flex", alignItems: "center", gap: "8px" }}
//               >
//                 <Box
//                   style={{
//                     width: "12px",
//                     height: "12px",
//                     backgroundColor: "#10B981",
//                     borderRadius: "2px",
//                   }}
//                 />
//                 <span
//                   style={{
//                     fontSize: "14px",
//                     color: "#10B981",
//                     fontWeight: "500",
//                   }}
//                 >
//                   Active
//                 </span>
//               </Box>
//               <Box
//                 style={{ display: "flex", alignItems: "center", gap: "8px" }}
//               >
//                 <Box
//                   style={{
//                     width: "12px",
//                     height: "12px",
//                     backgroundColor: "#EF4444",
//                     borderRadius: "2px",
//                   }}
//                 />
//                 <span
//                   style={{
//                     fontSize: "14px",
//                     color: "#EF4444",
//                     fontWeight: "500",
//                   }}
//                 >
//                   Inactive
//                 </span>
//               </Box>
//             </Box>
//           </Box>
//         </Box>
//       </Box>
//     </Box>
//   );
// };

// export default HiringCompanies;
import { Box } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCompanyStats } from "../redux/slices/companyStatsSlice";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Legend,
} from "recharts";

const HiringCompanies = ({ sidebarOpen = true }) => {
  const dispatch = useDispatch();

  // Get company stats from Redux store
  const { totalCompanies, activeCompanies, inactiveCompanies, loading, error } =
    useSelector((state) => state.companyStats);

  // Fetch data from API using Redux thunk
  useEffect(() => {
    dispatch(fetchCompanyStats());
  }, [dispatch]);

  // Calculate sidebar width based on state
  const sidebarWidth = sidebarOpen ? 200 : 90;

  // Data for bar chart (unchanged)
  const barData = [
    { name: "TechGiant Inc.", hires: 520 },
    { name: "InnovaCorp", hires: 180 },
    { name: "GlobalTech", hires: 340 },
    { name: "NextGen Ltd.", hires: 320 },
    { name: "FutureSoft", hires: 290 },
  ];

  // Data for pie chart (now using Redux data - showing counts instead of percentages)
  const pieData = [
    {
      name: "Active",
      value: activeCompanies,
      count: activeCompanies,
    },
    {
      name: "Inactive",
      value: inactiveCompanies,
      count: inactiveCompanies,
    },
  ];

  // Colors for charts
  const barColors = ["#3B82F6", "#10B981", "#EF4444", "#F59E0B", "#8B5CF6"];
  const pieColors = ["#10B981", "#EF4444"];

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div
          style={{
            backgroundColor: "white",
            padding: "12px 16px",
            border: "1px solid #E5E7EB",
            borderRadius: "8px",
            boxShadow: "0 10px 25px rgba(0, 0, 0, 0.15)",
            fontSize: "14px",
            fontWeight: "500",
          }}
        >
          <p style={{ margin: 0, color: "#374151" }}>
            {`${label}: ${payload[0].value} hires`}
          </p>
        </div>
      );
    }
    return null;
  };

  const PieTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div
          style={{
            backgroundColor: "white",
            padding: "8px 12px",
            border: "1px solid #E5E7EB",
            borderRadius: "6px",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          }}
        >
          <p style={{ margin: 0, fontSize: "13px", color: "#374151" }}>
            {`${payload[0].name}: ${payload[0].value}%`}
          </p>
        </div>
      );
    }
    return null;
  };

  const renderCustomizedLabel = ({ cx, cy, percent }) => {
    if (percent > 0.6) {
      return (
        <text
          x={cx}
          y={cy}
          fill="#10B981"
          textAnchor="middle"
          dominantBaseline="central"
          fontSize="20px"
          fontWeight="600"
        >
          {/* 75.00% */}
        </text>
      );
    }
    return null;
  };

  return (
    <Box
      sx={{
        padding: {
          xs: "12px",
          sm: "16px",
          md: "20px",
          lg: "24px",
          xl: "24px",
        },
        ml: {
          xs: "0px",
          sm: "0px",
          md: `${sidebarWidth}px`,
          lg: `${sidebarWidth}px`,
          xl: `${sidebarWidth}px`,
        },
        transition: "margin-left 0.3s ease",
        mt: {
          xs: "0",
          sm: "0",
          md: "-1%",
          lg: "-1%",
          xl: "-1%",
        },
        fontFamily: "system-ui, -apple-system, sans-serif",
      }}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "1fr",
            md: "1fr 1fr",
            lg: "2fr 2fr",
            xl: "2fr 2fr",
          },
          gap: {
            xs: "16px",
            sm: "20px",
            md: "24px",
            lg: "24px",
            xl: "24px",
          },
          marginLeft: {
            xs: "0",
            sm: "0",
            md: "1%",
            lg: "1%",
            xl: "1%",
          },
          marginRight: {
            xs: "0",
            sm: "0",
            md: "2%",
            lg: "2%",
            xl: "2%",
          },
        }}
      >
        {/* Top Hiring Companies Chart */}
        <Box
          sx={{
            backgroundColor: "white",
            padding: {
              xs: "16px",
              sm: "20px",
              md: "24px",
              lg: "24px",
              xl: "24px",
            },
            borderRadius: "12px",
            border: "1px solid #E5E7EB",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.05)",
            position: "relative", // Add this for overlay positioning
          }}
        >
          <Box sx={{ marginBottom: { xs: "16px", sm: "20px" } }}>
            <h2
              style={{
                fontSize: "18px",
                fontWeight: "600",
                color: "#111827",
                margin: "0 0 8px 0",
                textAlign: "left",
              }}
            >
              Top Hiring Companies
            </h2>
            <Box
              sx={{
                display: "flex",
                gap: { xs: "12px", sm: "24px" },
                alignItems: "center",
                flexWrap: "wrap",
                flexDirection: { xs: "column", sm: "row" },
                alignItems: { xs: "flex-start", sm: "center" },
              }}
            >
              <span style={{ fontSize: "13px", color: "#6B7280" }}>
                Total Hires: 1,670
              </span>
              <span style={{ fontSize: "13px", color: "#6B7280" }}>
                Top Hiring Company: TechGiant Inc.
              </span>
            </Box>
          </Box>

          <Box
            sx={{
              height: { xs: "280px", sm: "300px", md: "320px" },
              width: "100%",
              filter: "blur(3px)", // Add blur effect
            }}
          >
            <ResponsiveContainer width="100%" height="100%">
              <BarChart
                data={barData}
                margin={{ top: 20, right: 30, left: 20, bottom: -20 }}
              >
                <CartesianGrid
                  strokeDasharray="3 3"
                  stroke="#F3F4F6"
                  vertical={false}
                />
                <XAxis
                  dataKey="name"
                  tick={{ fontSize: 11, fill: "#6B7280" }}
                  angle={-45}
                  textAnchor="end"
                  height={80}
                  interval={0}
                  axisLine={{ stroke: "#E5E7EB" }}
                  tickLine={{ stroke: "#E5E7EB" }}
                />
                <CartesianGrid
                  strokeDasharray="3 3"
                  stroke="#F3F4F6"
                  horizontal={false}
                  vertical={true}
                />
                <YAxis
                  tick={{ fontSize: 11, fill: "#6B7280" }}
                  label={{
                    value: "Number of Hires",
                    angle: -90,
                    position: "insideLeft",
                    style: {
                      textAnchor: "middle",
                      fontSize: "12px",
                      fill: "#6B7280",
                    },
                  }}
                  axisLine={{ stroke: "#E5E7EB" }}
                  tickLine={{ stroke: "#E5E7EB" }}
                />
                {/* <Tooltip
                  content={<CustomTooltip />}
                  cursor={{ fill: "transparent" }}
                /> */}
                <Bar
                  dataKey="hires"
                  radius={[25, 25, 0, 0]}
                  stroke="#fff"
                  strokeWidth={1}
                  barSize={100}
                >
                  {barData.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={barColors[index]}
                      style={{
                        filter: "drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1))",
                      }}
                    />
                  ))}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </Box>

          {/* Coming Soon Overlay */}
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(255, 255, 255, 0.7)",
              borderRadius: "12px",
              zIndex: 10,
            }}
          >
            <h3
              style={{
                margin: "0",
                fontSize: "28px",
                fontWeight: "700",
                color: "#2B3674",
                fontFamily: "Outfit",
                textAlign: "center",
                textShadow: "0 2px 4px rgba(0,0,0,0.1)",
              }}
            >
              Coming Soon
            </h3>
          </Box>
        </Box>

        {/* Active vs Inactive Companies Chart */}
        <Box
          sx={{
            backgroundColor: "white",
            padding: {
              xs: "16px",
              sm: "20px",
              md: "24px",
              lg: "24px",
              xl: "24px",
            },
            borderRadius: "12px",
            border: "1px solid #E5E7EB",
            position: "relative",
          }}
        >
          <Box sx={{ marginBottom: { xs: "16px", sm: "20px" } }}>
            <h2
              style={{
                fontSize: "20px",
                fontWeight: "600",
                color: "#111827",
                margin: "0 0 8px 0",
                textAlign: "left",
              }}
            >
              Active vs. Inactive Companies
            </h2>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                flexDirection: { xs: "column", sm: "row" },
                gap: { xs: "8px", sm: "0" },
                alignItems: { xs: "flex-start", sm: "center" },
              }}
            >
              <span style={{ fontSize: "14px", color: "#6B7280" }}>
                Total Companies: {totalCompanies}
              </span>
              <span
                style={{
                  fontSize: "14px",
                  color: "#10B981",
                  fontWeight: "500",
                }}
              >
                Active Companies: {activeCompanies}
              </span>
            </Box>
          </Box>

          {loading && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "200px",
              }}
            >
              <span style={{ fontSize: "16px", color: "#6B7280" }}>
                Loading...
              </span>
            </Box>
          )}

          {error && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "200px",
              }}
            >
              <span style={{ fontSize: "16px", color: "#EF4444" }}>
                Error: {error}
              </span>
            </Box>
          )}

          {!loading && !error && (
            <Box
              sx={{
                height: { xs: "280px", sm: "300px", md: "320px" },
                width: "100%",
              }}
            >
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie
                    data={[
                      {
                        name: "Active",
                        value: activeCompanies,
                        color: "#10B981",
                      },
                      {
                        name: "Inactive",
                        value: inactiveCompanies,
                        color: "#EF4444",
                      },
                    ]}
                    cx="50%"
                    cy="45%"
                    labelLine={{
                      stroke: "#6B7280",
                      strokeWidth: 1.5,
                    }}
                    label={({
                      name,
                      value,
                      cx,
                      cy,
                      midAngle,
                      innerRadius,
                      outerRadius,
                    }) => {
                      const RADIAN = Math.PI / 180;
                      const radius =
                        innerRadius + (outerRadius - innerRadius) * 1.5;
                      const x = cx + radius * Math.cos(-midAngle * RADIAN);
                      const y = cy + radius * Math.sin(-midAngle * RADIAN);
                      const color = name === "Active" ? "#10B981" : "#EF4444";

                      // Adjust y position for cleaner look
                      const adjustedY = name === "Active" ? y - 18 : y + 18;

                      return (
                        <text
                          x={x}
                          y={adjustedY}
                          fill={color}
                          textAnchor={x > cx ? "start" : "end"}
                          dominantBaseline="central"
                          fontSize="14px"
                          fontWeight="500"
                        >
                          {`${name}: ${value}`}
                        </text>
                      );
                    }}
                    outerRadius={70}
                    innerRadius={45}
                    fill="#8884d8"
                    dataKey="value"
                    startAngle={90}
                    endAngle={450}
                    paddingAngle={2}
                  >
                    <Cell fill="#10B981" />
                    <Cell fill="#EF4444" />
                  </Pie>
                  {/* <Tooltip
                    formatter={(value) => [value, ""]}
                    labelStyle={{ display: "none" }}
                  /> */}
                </PieChart>
              </ResponsiveContainer>

              {/* Custom Legend */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: { xs: "16px", sm: "24px" },
                  marginTop: "-30px",
                  flexDirection: { xs: "column", sm: "row" },
                }}
              >
                <Box
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  <Box
                    style={{
                      width: "12px",
                      height: "12px",
                      backgroundColor: "#10B981",
                      borderRadius: "2px",
                    }}
                  />
                  <span
                    style={{
                      fontSize: "14px",
                      color: "#10B981",
                      fontWeight: "500",
                    }}
                  >
                    Active
                  </span>
                </Box>
                <Box
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  <Box
                    style={{
                      width: "12px",
                      height: "12px",
                      backgroundColor: "#EF4444",
                      borderRadius: "2px",
                    }}
                  />
                  <span
                    style={{
                      fontSize: "14px",
                      color: "#EF4444",
                      fontWeight: "500",
                    }}
                  >
                    Inactive
                  </span>
                </Box>
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default HiringCompanies;
